import { render, staticRenderFns } from "./AdditionalProduct_fix_yareto.vue?vue&type=template&id=2f573f69&scoped=true"
import script from "./AdditionalProduct_fix_yareto.vue?vue&type=script&lang=js"
export * from "./AdditionalProduct_fix_yareto.vue?vue&type=script&lang=js"
import style0 from "./AdditionalProduct_fix_yareto.vue?vue&type=style&index=0&id=2f573f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f573f69",
  null
  
)

export default component.exports